import breakpointsJson from './lib/breakpoints.json'
import colorsJson from './lib/colors.json'
import { ReactComponent as Defs } from './lib/defs.svg'
const { breakpoints } = breakpointsJson
const { colors } = colorsJson

export * from './lib/components'
export { breakpoints, Defs, colors }
